import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "100bc06a-9180-4780-96b0-9a9256ce1d4e",
    content: "Linear increase",
    options: {},
  },
  {
    id: "1a7d2c29-afc4-473a-985f-88e3d35957a1",
    content: "It is constant for N >= 3",
    options: {},
  },
  {
    id: "59c86277-c0d7-427d-9f3e-79e406b8ac40",
    content: "Irregular increase",
    options: {},
  },
  {
    id: "3dd184ff-516e-439e-ab13-ff6db0f3e251",
    content: "Exponentrial increase",
    options: {},
  },
];

export const task: Task = {
  id: "50f5257f-c142-4868-94bf-b39a9771e280",
  solutionType: "select",
  type: "checkbox",
  options: {
    columns: 2,
    isMultiple: false,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["3dd184ff-516e-439e-ab13-ff6db0f3e251"],
};
